app.directive(
    'fileModel', ['$parse', function ($parse) {
        return {
            restrict : 'A',
            link : function (scope, element, attrs) {
                var model = $parse(attrs.fileModel);
                var modelSetter = model.assign;

                element.bind(
                    'change', function () {
                        scope.$apply(
                            function () {
                                modelSetter(scope, element[0].files[0]);
                            }
                        );
                    }
                );
            }
        };
    }]
);

app.directive('fileChange', function(){
    return {
        scope: {
            fileChange:'&'
        },
        link:function($scope, $element, $attrs){
            $element.on('change', function(event){
                $scope.fileChange({$event:event});
            });
            $scope.$on('$destroy', function(){
                $element.off();
            });
        }
    }
});

app.directive(
    'dropdown', function ($document) {
        return {
            restrict : "C",
            link : function (scope, elem, attr) {

                elem.bind(
                    'click', function () {
                        elem.toggleClass('dropdown-active');
                        elem.addClass('active-recent');
                    }
                );

                $document.bind(
                    'click', function () {
                        if (!elem.hasClass('active-recent')) {
                            elem.removeClass('dropdown-active');
                        }
                        elem.removeClass('active-recent');
                    }
                );

            }
        }
    }
);